import React from "react";
import classNames from "classnames";
import ClipLoader from 'react-spinners/ClipLoader';

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import {Card, CardActions, CardContent} from "@material-ui/core";
import ReactToPrint from "react-to-print";
import {Alert, Button} from "reactstrap";


/**
 *  @property {Certificates_Object} state
 *  @property {object} model
 *  @property {Certificates_Properties} model.properties
 *  @property {Certificates_Is} model.is
 *  @property {Certificates_Has} model.has
 */

export default class CertificateObject extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Certificates._name);
		this.state.certificateBarcodeCapture = false;
		this.certificateBarcodeCaptureHandler = null;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		/** @type {Certificates_Object} object */
		let object = this.state;
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name);
		}
	}

	componentWillUnmount() {
		this.clearCertificateBarcodeCapture(false);
		if (super.componentWillUnmount) {
			super.componentWillUnmount();
		}
	}

	captureCertificateBarcode = () => {
		this.clearCertificateBarcodeCapture();
		this.certificateBarcodeCaptureHandler = (barcode) => {
			this.clearCertificateBarcodeCapture();
			this.setState({
				code: String(barcode || '').trim(),
				certificateBarcodeCapture: false,
			});
			return true;
		};
		window.BestPOSGiftCertificateBarcodeCapture = this.certificateBarcodeCaptureHandler;
		this.setState({certificateBarcodeCapture: true});
	}

	clearCertificateBarcodeCapture = (updateState = true) => {
		if (window.BestPOSGiftCertificateBarcodeCapture === this.certificateBarcodeCaptureHandler) {
			delete window.BestPOSGiftCertificateBarcodeCapture;
		}
		this.certificateBarcodeCaptureHandler = null;
		if (updateState && this.state?.certificateBarcodeCapture) {
			this.setState({certificateBarcodeCapture: false});
		}
	}

	form = () => {
		let {properties} = this.model;

		/**
		 *  @type {Certificates_Object} object
		 */
		let object = this.state;

		return (
			<div>
				<fieldset>
					<h4 className="section-title">Certificate</h4>
					<div className="row">
						<div className="col-md">
							<div className={'row'}>
								<div className={'col-8 form-group'}>
									<Framework.Elements.TextField
										label={"Certificate Code"}
										property={properties.code}
										value={object.code}
										error={object.code_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className={'col-4 form-group'} style={{display: 'flex', alignItems: 'flex-end', paddingBottom: 16}}>
									<Button
										color={this.state.certificateBarcodeCapture ? "secondary" : "info"}
										onClick={this.state.certificateBarcodeCapture ? this.clearCertificateBarcodeCapture : this.captureCertificateBarcode}
									>
										{this.state.certificateBarcodeCapture ? "Cancel Scan" : "Capture Scan"}
									</Button>
								</div>
							</div>
							{this.state.certificateBarcodeCapture &&
								<Alert color="info">Scan the gift certificate now. The scanned code will be saved when you save the certificate.</Alert>}
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Recipient Name"}
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.DollarAmount
									label={"Certificate Value"}
									property={properties.value}
									value={object.value}
									error={object.value_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className="col-md">

							<div className="form-group">
								<Framework.Elements.PhoneNumber
									property={properties.phone}
									value={object.phone}
									error={object.phone_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Email"}
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							{object.pkey ?

								<div className="form-group">
									<Framework.Elements.TextField
										label={"Status"}
										property={properties.used}
										value={(object.used ? "Used" : " ")}
										error={object.used_error}
										update={this.handleTextFieldPropertyUpdate}
										disabled={"true"}
									/>
								</div>
								: null}
						</div>
					</div>
				</fieldset>

				{object.pkey && object.pkey ?
					<Framework.Printable.Label
						ref={el => (this['printable'] = el)}
						prefix="GC"
						code={object.pkey}
						label={object.code + "\n $" + object.value}
					/> : null
				}

				<div className={classNames("loader", {'active': this.state.loading})}>
					<ClipLoader color={"#4A4A4A"} loading={this.state.loading}/>
				</div>
			</div>
		);
	}

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					<ReactToPrint
						trigger={() =>
							<Button className="secondary-button" style={{marginRight: 'auto'}}>Print Label</Button>
						}
						content={() => this['printable']}
						copyStyles={false}
						pageStyle={'@media print { body { -webkit-print-color-adjust: exact; margin: 0 } @page { margin: 0 }}'}
						bodyClass={""}
					/>
					<Button color="danger" onClick={this.handleDelete}>Delete</Button>
					<Button className="primary-button" onClick={this.handleSubmit}>Save</Button>
				</CardActions>
			</Card>
		);
	}
}
